import { inject, Injectable } from '@angular/core';
import { APIService } from './api.service';
import { environment } from 'src/environments/environment';
import { Table } from 'src/app/models/ui/table';
import { HttpClient } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { Gruppe, MRproResponseInfo } from 'src/app/types/api';
import { BegehungResult } from 'src/app/content/begehung/begehung.component';
import {
  BegehungsEinstellungen,
  BegehungZuordnung,
} from 'src/app/content/begehung/begehungseinstellungen/begehungseinstellungen.component';
import { BegehungDB } from '../_offline/begehungDB';

const ROUTE = `${environment.apiUrl}/begehung/`;

@Injectable({
  providedIn: 'root',
})
export class BegehungApiService {
  private readonly api = inject(APIService);
  private readonly http = inject(HttpClient);
  private readonly begehungDB = inject(BegehungDB);
  private readonly options = this.api.AUTH_HEADER;

  public isRep = this.api.isRep;
  //#region Begehung
  //#region verwaltung
  public getGruppen() {
    return this.http.get<Gruppe[]>(ROUTE + `groups`, this.options);
  }

  public getEinstellungenTable() {
    return this.http.get<Table<BegehungsEinstellungen>>(ROUTE + `einstellungen/table`, this.options);
  }
  public setBegehungsEinstellungen(sendObj: BegehungsEinstellungen) {
    return this.http.post<number>(ROUTE + `einstellungen`, sendObj, this.options);
  }
  public deleteBegehungsEinstellungen(obegeid: number) {
    return this.http.delete(ROUTE + `einstellungen/${obegeid}`, this.options);
  }

  public getAllZuordnungen() {
    return this.http.get<BegehungZuordnung[]>(ROUTE + `objekte`, this.options);
  }
  public addZuordnungen(obegeid: number, sendObj: number[]) {
    return this.http.post(ROUTE + `objekte/${obegeid}`, sendObj, this.options);
  }
  public deleteZuordnungen(obegeid: number, sendObj: number[]) {
    return this.http.post(ROUTE + `objekte/delete/${obegeid}`, sendObj, this.options);
  }
  //#endregion

  //#region plan
  public getBegehungsplan(userId = 0) {
    return this.isRep ?
        from(this.begehungDB.getBegehungsplan())
      : this.http.get<MRproResponseInfo<BegehungResult>>(ROUTE + `begehungsplan/${userId}`, this.options);
  }

  public getBegehungsplanHistory(obegeid: number) {
    return this.isRep ?
        from(this.begehungDB.getBegehungsplanHistory(obegeid))
      : this.http.get<MRproResponseInfo<BegehungResult>>(ROUTE + `begehungsplan/history/${obegeid}`, this.options);
  }
  //#endregion

  //#region kalender
  public getBegehungsCalendarList(): Observable<any> {
    return this.http.get(ROUTE + `calendar`, this.options);
  }
  //#endregion

  //#region begehung
  public setBegehung(sendObj: any): Observable<any> {
    return this.isRep ?
        from(this.begehungDB.setBegehung(sendObj))
      : this.http.post(ROUTE + `setbegehung`, sendObj, this.options);
  }
  //#endregion
  //#endregion
}
